<template>
  <svg width="28"
       height="28"
       viewBox="0 0 28 28"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1_2927)">
      <path d="M7.60156 14.7002C7.60156 15.0605 7.88281 15.333 8.26953 15.333H13.3672L10.6865 22.5312C10.3262 23.4893 11.3193 23.999 11.9521 23.2256L20.1611 13.0654C20.3193 12.8633 20.3984 12.6787 20.3984 12.4766C20.3984 12.1074 20.1172 11.8438 19.7305 11.8438H14.6328L17.3135 4.63672C17.6738 3.67871 16.6807 3.16895 16.0479 3.95117L7.84766 14.1113C7.68945 14.3047 7.60156 14.4893 7.60156 14.7002Z"
            :fill="color"/>
    </g>
    <defs>
      <clipPath id="clip0_1_2927">
        <rect width="28"
              height="28"
              fill="white"/>
      </clipPath>
    </defs>
  </svg>

</template>

<script>
export default {
  name: 'LightningIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>

<style>

</style>
